import { createWebSocketStore } from 'src/components/#services/helpers';
export const getItemsCount = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'marketPlaceEndpoints_getItemsCount',
        agent: 'meowgon-inventory',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const getUnitsByFilter = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'unitEndpoints_getUnitsByFilters',
        agent: 'meowgon-inventory',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const getItemsByFilter = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'inventoryEndpoints_getByFilter',
        agent: 'meowgon-inventory',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const getNft = createWebSocketStore({
    auth: false,
    requestTemplate: {
        method: 'inventoryEndpoints_getItemByProductId',
        agent: 'meowgon-inventory',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const getLootboxes = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'marketPlaceEndpoints_getLootboxes',
        agent: 'meowgon-inventory',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const openLootbox = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'marketPlaceEndpoints_openLootbox',
        agent: 'meowgon-inventory',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const getUnit = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'unitEndpoints_getByProductIdAndUserId',
        agent: 'meowgon-inventory',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const getEgg = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'inventoryEndpoints_getByProductIdAndUserId',
        agent: 'meowgon-inventory',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const addToMarketPlace = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'marketPlaceEndpoints_addToMarketPlace',
        agent: 'meowgon-inventory',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const cancelSell = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'marketPlaceEndpoints_cancelSale',
        agent: 'meowgon-inventory',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const exportUnit = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'unitEndpoints_exportUnit',
        agent: 'meowgon-inventory',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
